<div class="alert-wrapper">
  <div id="success">
    <ng-container [ngSwitch]="resultstate.alertType">

      <ng-container *ngSwitchCase="'Success'">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
          <g id="ic-ok" transform="translate(0 -12)">
            <g id="ok" transform="translate(0 12)">
              <g id="Oval_55" data-name="Oval 55">
                <g id="Oval_55-2" data-name="Oval 55" fill="#004A63" stroke="#004A63" stroke-miterlimit="10"
                  stroke-width="2">
                  <circle cx="30" cy="30" r="30" stroke="none" />
                  <circle cx="30" cy="30" r="29" fill="none" />
                </g>
                <circle id="Oval_55-3" data-name="Oval 55" cx="30" cy="30" r="30" fill="none" />
              </g>
              <path id="Path_3" data-name="Path 3" d="M0,10.672l6.621,6.4L24.178,0" transform="translate(18.622 21.889)"
                fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                stroke-width="4" />
            </g>
          </g>
        </svg>
      </ng-container>

      <ng-container *ngSwitchCase="'Failed'">
        <i _ngcontent-wsp-c4="" class="icon-spacing failur-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
            <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
              <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
                <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
              </g>
            </g>
          </svg>
        </i>
      </ng-container>

      <ng-container *ngSwitchCase="'Warning'">
        <i _ngcontent-wsp-c4="" class="icon-spacing" style="
            width: 60px;
            height: 60px;
            background-color: #ff0000;
            border-radius: 50%;
            line-height: 60px;
          ">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
            <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
              <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="4"></line>
                <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="4"></line>
              </g>
            </g>
          </svg>
        </i>
      </ng-container>

    </ng-container>

    <h2>{{ resultstate.title | titlecase }}</h2>

    <div class="result-message">
      <ng-container *ngIf="resultstate.message">
        <p>{{ resultstate.message }}</p>
      </ng-container>
      
    </div>

    <ng-container *ngFor="let item of resultstate.navigationDtls">
      <ng-container *ngIf="item.btnType; else defaultButton">
        <button class="btn-{{item.btnType}}" clickable (click)="resultButtonClickHandler(item)">
          {{ item.btnLabel }}
        </button>
      </ng-container>
      <ng-template #defaultButton>
        <button class="btn-secondary" clickable (click)="resultButtonClickHandler(item)">
          {{ item.btnLabel }}
        </button>
      </ng-template>

    </ng-container>

  </div>
</div>